import { Trans, useLingui } from "@lingui/react";
import { Button, Modal } from "@warp-ds/react";
import { useEffect, useState } from "react";
import { useTracking } from "../../utils/pulseHelper.ts";

export const logInToSendMessageEventId = "log-in-to-send-message";
export const logInToReserveCarEventId = "log-in-to-reserve-car";

enum ModalVariations {
  LogInToSendMessage,
  LogInToReserveCar,
}

export const LoginModal = () => {
  const [open, setOpen] = useState(false);
  const [nextUrl, setNextUrl] = useState("");
  const [variation, setVariation] = useState<ModalVariations>(ModalVariations.LogInToSendMessage);
  const { i18n } = useLingui();

  const { trackLogin, trackCancelLoginModal } = useTracking();

  useEffect(() => {
    const openWith = (variant: ModalVariations) => {
      const { origin, pathname } = window.location;
      const url = new URL(`${origin}/auth/login`);
      const redirectUrl =
        variant === ModalVariations.LogInToSendMessage ? `${origin}${pathname}?contact` : `${origin}${pathname}`;

      url.searchParams.set("redirectUrl", redirectUrl);
      url.searchParams.set("cancelUrl", `${origin}${pathname}`);

      setVariation(variant);
      setNextUrl(url.toString());
      setOpen(true);
    };

    window.addEventListener(logInToSendMessageEventId, () => openWith(ModalVariations.LogInToSendMessage));
    window.addEventListener(logInToReserveCarEventId, () => openWith(ModalVariations.LogInToReserveCar));
    return () => {
      window.removeEventListener(logInToSendMessageEventId, () => openWith(ModalVariations.LogInToSendMessage));
      window.removeEventListener(logInToReserveCarEventId, () => openWith(ModalVariations.LogInToReserveCar));
    };
  }, []);

  const onDismiss = () => {
    setOpen(false);
    trackCancelLoginModal();
  };

  const loginModalTitle = i18n.t({ id: "dealer.loginModal.fomo.title", message: "You're not the only one interested" });

  const loginModalText = {
    [ModalVariations.LogInToSendMessage]: i18n.t({
      id: "dealer.loginModal.fomo.description",
      message:
        "Log in and write to the seller before someone else strikes.\n" +
        "You can also save the ad or get notified when something similar appears.",
    }),
    [ModalVariations.LogInToReserveCar]: i18n.t({
      id: "dealer.loginModal.reserve.description",
      message:
        "Log in to reserve the car before someone else does.\n" +
        "You can also save the ad or get notified when something similar appears.",
    }),
  };

  return (
    <Modal right open={open} onDismiss={onDismiss} title={loginModalTitle}>
      <p className="mb-32">{loginModalText[variation]}</p>
      <div className="flex w-full md:w-[50%] ml-auto gap-8">
        <Button secondary quiet fullWidth onClick={onDismiss}>
          <Trans id="dealer.loginModal.cancel" message="Not now" />
        </Button>
        <Button primary fullWidth href={nextUrl} onClick={() => trackLogin()}>
          <Trans id="dealer.loginModal.logIn" message="Log in" />
        </Button>
      </div>
    </Modal>
  );
};
